<template>
  <modal name="finance-refund-detail" width="94%" :max-width="1080" height="auto" adaptive scrollable :click-to-close="!busy" @before-close="beforeClose" @opened="focusClose">
    <section class="safari-cancellation-modal" role="dialog" aria-modal="true" aria-labelledby="finance-refund-title">
      <AppModalHeader ref="header" design="new" :title="detail ? detail.client_name : 'Client refund'" eyebrow="Client refund" title-id="finance-refund-title" @close="close" />
      <div v-if="loading" class="cancellation-content" aria-busy="true"><div class="cancellation-skeleton" /></div>
      <div v-else-if="error" class="cancellation-content"><p role="alert">{{ error }}</p><AppButton design="new" @click.native="load">Retry</AppButton></div>
      <RefundPanel v-else-if="detail" :key="`${detail.id}-${selection.kind}-${selection.id}`" :refund="detail" :payout-id="payoutId" @busy="busy = $event" @updated="updated" />
    </section>
  </modal>
</template>
<script>
import AppModalHeader from '@/components/AppModalHeader'
import AppButton from '@/components/AppButton'
import RefundPanel from './RefundPanel'
import { getFinanceRefund, getFinanceRefundPayout } from '@/http'
import { errorMessage } from '@/views/safari/cancellations/format'
export default {
  name: 'FinanceRefundDetailModal',
  components: { AppModalHeader, AppButton, RefundPanel },
  props: { selection: { type: Object, default: null } },
  data() { return { detail: null, payoutId: null, loading: false, error: '', busy: false, requestId: 0 } },
  watch: { selection: { deep: true, handler() { this.sync() } } },
  mounted() { this.sync() },
  beforeDestroy() { this.requestId += 1 },
  methods: {
    sync() { if (this.selection) { this.$modal.show('finance-refund-detail'); this.load() } else this.$modal.hide('finance-refund-detail') },
    async load() {
      if (!this.selection) return
      const current = ++this.requestId
      this.loading = true
      this.error = ''
      this.detail = null
      const isPayout = this.selection.kind === 'payout'
      try {
        const { data } = await (isPayout ? getFinanceRefundPayout : getFinanceRefund)(this.selection.id)
        if (current === this.requestId) { this.detail = isPayout ? data.refund : data; this.payoutId = isPayout ? data.id : null }
      } catch (error) { if (current === this.requestId) this.error = errorMessage(error) } finally { if (current === this.requestId) { this.loading = false; this.$nextTick(this.focusClose) } }
    },
    focusClose() { if (this.$refs.header) this.$refs.header.focusClose() },
    close() { if (!this.busy) this.$modal.hide('finance-refund-detail') },
    beforeClose(event) { if (this.busy) { event.cancel(); return } this.requestId += 1; this.$emit('close') },
    updated(data) { this.detail = data; this.$emit('updated') }
  }
}
</script>
